<template>
  <div>
    <div class="list-analytics analysis-chart" v-show="mainChartVisible">
      <div class="t-chart c-pointer">
        <div class="title corner" @click="onClickAddButton">
            HOST
            <div :class="addButtonIconName"></div>
        </div>
        <w-common-line-chart ref="deviceTrafficChart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" />
      </div>
    </div>

    <div v-show="subChartVisible" class="sub-chart-wrapper">
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">메모리</div>
          <w-common-line-chart ref="ppsChart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['MEMORY']" />
        </div>
      </div>
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">NET I/O</div>
          <w-common-line-chart ref="userateChart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['NETIO']" />
        </div>
      </div>
      <div class="list-analytics analysis-chart">
        <div class="t-chart">
          <div class="title">디스크 스왑</div>
          <w-common-line-chart ref="userateChart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['DISK']" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { performanceChart } from '@/mixins/performance/charts';
import WCommonLineChart from './CommonLineChart';

export default {
  name: 'WHostAnalysisChart',
  components: { WCommonLineChart },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
  },
  data() {
    return {
      mainRscInfoList: [{ rsctypeId: 'HOST', rscId: 'CPU', rscKey: '_' }],
      subRscInfo: {
        MEMORY: [{ rsctypeId: 'HOST', rscId: 'MEM', rscKey: '_' }],
        NETIO: [{ rsctypeId: 'HOST', rscId: 'NET_RX_BYTES', rscKey: '_' }, { rsctypeId: 'HOST', rscId: 'NET_TX_BYTES', rscKey: '_' }],
        DISK: [{ rsctypeId: 'HOST', rscId: 'SWAP_T', rscKey: '_' }, { rsctypeId: 'HOST', rscId: 'SWAP_U', rscKey: '_' }],
      },
      subChartVisible: false,
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/apm/components/chart/HostAnalysisChart.vue